<template>
  <el-popover
    placement="top-start"
    title="Opções"
    width="400"
    trigger="hover">
    <el-row v-for="option of listOptions" :key="option.key">
      <el-col :xs="24">
        <el-button type="text" @click="open(option.key)">{{ option.description }}</el-button>
      </el-col>
    </el-row>
    <el-button slot="reference" title="Opções" class="w-50" type="default" icon="el-icon-setting"><span class="hidden-lg-and-down">Opções</span></el-button>
  </el-popover>
</template>

<script>
export default {
  props: ["listOptions"],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    get() {
      return this.filter;
    },
    open(action) {
      const vm = this;
      vm.$emit('option', action);
    },
  }
}
</script>